import { render } from "./RFIFilters.vue?vue&type=template&id=fa837d1e"
import script from "./RFIFilters.vue?vue&type=script&lang=js"
export * from "./RFIFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__